import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["children", "styleType", "stylePosition", "spacing"],
  _excluded2 = ["as"],
  _excluded3 = ["as"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// src/list.tsx
import { Icon } from "@chakra-ui/icon";
import { createContext } from "@chakra-ui/react-context";
import { getValidChildren } from "@chakra-ui/react-children-utils";
import { chakra, forwardRef, omitThemingProps, useMultiStyleConfig } from "@chakra-ui/system";
import { jsx } from "react/jsx-runtime";
var _createContext = createContext({
    name: "ListStylesContext",
    errorMessage: "useListStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<List />\" "
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  ListStylesProvider = _createContext2[0],
  useListStyles = _createContext2[1];
var List = forwardRef(function List2(props, ref) {
  var styles = useMultiStyleConfig("List", props);
  var _omitThemingProps = omitThemingProps(props),
    children = _omitThemingProps.children,
    _omitThemingProps$sty = _omitThemingProps.styleType,
    styleType = _omitThemingProps$sty === void 0 ? "none" : _omitThemingProps$sty,
    stylePosition = _omitThemingProps.stylePosition,
    spacing = _omitThemingProps.spacing,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  var validChildren = getValidChildren(children);
  var selector = "& > *:not(style) ~ *:not(style)";
  var spacingStyle = spacing ? _defineProperty({}, selector, {
    mt: spacing
  }) : {};
  return /* @__PURE__ */jsx(ListStylesProvider, {
    value: styles,
    children: /* @__PURE__ */jsx(chakra.ul, _objectSpread(_objectSpread({
      ref: ref,
      listStyleType: styleType,
      listStylePosition: stylePosition,
      role: "list",
      __css: _objectSpread(_objectSpread({}, styles.container), spacingStyle)
    }, rest), {}, {
      children: validChildren
    }))
  });
});
List.displayName = "List";
var OrderedList = forwardRef(function (props, ref) {
  var as = props.as,
    rest = _objectWithoutProperties(props, _excluded2);
  return /* @__PURE__ */jsx(List, _objectSpread({
    ref: ref,
    as: "ol",
    styleType: "decimal",
    marginStart: "1em"
  }, rest));
});
OrderedList.displayName = "OrderedList";
var UnorderedList = forwardRef(function UnorderedList2(props, ref) {
  var as = props.as,
    rest = _objectWithoutProperties(props, _excluded3);
  return /* @__PURE__ */jsx(List, _objectSpread({
    ref: ref,
    as: "ul",
    styleType: "initial",
    marginStart: "1em"
  }, rest));
});
UnorderedList.displayName = "UnorderedList";
var ListItem = forwardRef(function ListItem2(props, ref) {
  var styles = useListStyles();
  return /* @__PURE__ */jsx(chakra.li, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    __css: styles.item
  }));
});
ListItem.displayName = "ListItem";
var ListIcon = forwardRef(function ListIcon2(props, ref) {
  var styles = useListStyles();
  return /* @__PURE__ */jsx(Icon, _objectSpread(_objectSpread({
    ref: ref,
    role: "presentation"
  }, props), {}, {
    __css: styles.icon
  }));
});
ListIcon.displayName = "ListIcon";
export { useListStyles, List, OrderedList, UnorderedList, ListItem, ListIcon };